import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    modalImageContainer: {
        height: "100%",
        justifyContent: "center",
        alignItems: "center"
    },
    modalImage: {
        width: "100%",
        height: "100%"
    }
});
export default stylesheet;
